import React, { type FC, useEffect } from 'react';

import ModalTransition from '@atlaskit/modal-dialog/modal-transition';

import { LoadableLazy } from '@confluence/loadable';

type ApprovalRequiredBeforePublishModalProps = {
	isOpen: boolean;
	isUnpublishedDraft: boolean;
	onClose: () => void;
};

const ApprovalRequiredBeforePublishModalContent = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ApprovalRequiredBeforePublishModal" */ './ApprovalRequiredBeforePublishModal.tsx'
			)
		).ApprovalRequiredBeforePublishModal,
});

export const ApprovalRequiredBeforePublishModal: FC<ApprovalRequiredBeforePublishModalProps> = ({
	isOpen,
	isUnpublishedDraft,
	onClose,
}) => {
	useEffect(() => {
		void ApprovalRequiredBeforePublishModalContent.preload();
	}, []);

	return (
		<ModalTransition>
			{isOpen ? (
				<ApprovalRequiredBeforePublishModalContent
					isUnpublishedDraft={isUnpublishedDraft}
					onClose={onClose}
				/>
			) : null}
		</ModalTransition>
	);
};
